import React from "react";

import { useTranslation } from "react-i18next";

import { FormTextInput } from "@/uiKit/molecules/form/FormTextInput.tsx";

export type PatientPhoneFormFieldProps = {
  name?: string;
  labelType?: "left" | "default";
  className?: string;
};

export const PatientPhoneFormField: React.FC<PatientPhoneFormFieldProps> = ({
  name = "phone",
  labelType = "default",
  className,
}) => {
  const { t } = useTranslation();
  return (
    <FormTextInput
      id="patient-phone-form-field"
      name={name}
      label={t("form.phone.label")}
      autoComplete="tel"
      reserveErrorSpace
      className={className}
      labelType={labelType}
    />
  );
};
